interface URLS{
  // facebook :string , 
  github :string , 
  linkedin : string , 
  twitter :string,
  instagram : string , 
  resume : string , 
  mail : string 
}
export const ProfileURL:URLS ={
  github  : 'https://github.com/devwithsammy',
  twitter : 'https://twitter.com/devwithsammy',
  // facebook  : 'https://web.facebook.com/samuel.yakubu.ohiani',
  linkedin : 'https://linkedin.com/in/devwithsammy',
  instagram : 'https://www.instagram.com/devwithsammy_/'
,  resume : 'https://docs.google.com/document/d/1WvZalEV9y6TxYQ8oVta3wcMzMIP3BRs1QKTwDE_LdUM/edit?usp=sharing',
mail : "mailto:devwithsammy@gmail.com"
}

